// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1xFBc","title":"InfoRow_title__2l4Nu"};